export const HOME_CONSTANTS = {
   SEARCH_DEBOUNCE_DELAY: 300,
   DEFAULT_SKELETON_ROWS: 17,
   DATA_GRID_HEIGHT: 'h-[700px]',
   HEADER_HEIGHT: 40,
   SEARCH_INPUT_WIDTH: 'w-64',
   SEARCH_INPUT_HEIGHT: 'h-10',
   ANIMATION_HEIGHT: 'h-[200px]',
   SURVEYS_PAGE: 1,
   SURVEYS_LIMIT: 30,
   INCLUDES: 'status,creator,updatedBy',
} as const;

export const DEFAULT_FILTERS = {
   EXCLUDE_CLOSED: {
      field: 'status.label',
      operator: 'in' as const,
      value: ['draft', 'open', 'paused'],
   },
   INCLUDE_CLOSED: {
      field: 'status.label',
      operator: 'in' as const,
      value: ['closed'],
   },
};

export const DATA_GRID_CLASS_NAMES = {
   base: `${HOME_CONSTANTS.DATA_GRID_HEIGHT} mt-2`,
   th: 'h-12',
} as const;

export const FOOTER_CLASS_NAMES = {
   footer: 'flex justify-end text-xs mt-1.5 mr-1',
} as const;
